module.exports = __webpack_public_path__ + "static/media/deweys.fd3aaa93.png";